















import Loader from '@/components/common/Loader.vue';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { storeService } from '@/services/StoreService';

@Component({
  components: { Loader },
})
export default class RegionAutoSelector extends Vue {
  intoLink = '';
  workspaceId = 0;
  isError = false;

  @Watch('$store.state.regions.regions', { immediate: true, deep: true })
  onRegionsChange() {
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    const regions = this.$store.state.regions.regions;
    const regionsWorkspaceId = this.$store.state.regions.regionsWorkspaceId;
    if (parseInt(regionsWorkspaceId, 10) !== this.workspaceId) {
      return;
    }
    if (!regions || !regions.length) {
      if (
        this.$store.state.regions.hasError &&
        parseInt(this.$store.state.regions.regionsWorkspaceId, 10) === this.workspaceId
      ) {
        // TODO: check if this is doesn't mess up something (it would be better to redirect to workspace-switch)
        this.$router.push(`/workspaces/${this.workspaceId}/select-payment-method`).catch(() => {});
      }
      return;
    }
    const activeRegions = regions.filter((item: any) => item.active);
    const inactiveRegions = regions.filter((item: any) => !item.active);
    if (activeRegions.length) {
      this.$router
        .push(`/workspaces/${this.workspaceId}/regions/${activeRegions[0].id}${this.intoLink}`)
        .catch(() => {});
    } else if (inactiveRegions.length) {
      this.$router
        .push(`/workspaces/${this.workspaceId}/regions/${inactiveRegions[0].id}${this.intoLink}`)
        .catch(() => {});
    } else {
      this.isError = true;
    }
  }

  mounted() {
    this.intoLink = this.$route.fullPath.indexOf('intro') !== -1 ? '/intro' : '';
    this.intoLink = this.$route.fullPath.indexOf('cardActivated') !== -1 ? '/cardActivated' : this.intoLink;
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    this.$store.commit('currentWorkspace/setWorkspaceId', this.workspaceId);
    storeService.getRegions();
  }
}
